module.exports = __webpack_public_path__ + "d85c8865e811f74a85068cc829f6d8fe.svg";